import React, { createContext, useContext } from "react";
import { DEFAULT_LANG, getLang } from "../config/site";

import en from "./locales/en";
import es from "./locales/es";
import tr from "./locales/tr";
import pt from "./locales/pt";
import fr from "./locales/fr";
import de from "./locales/de";
import it from "./locales/it";
import ar from "./locales/ar";
import hi from "./locales/hi";
import ja from "./locales/ja";
import ko from "./locales/ko";
import zh from "./locales/zh";

const RAW = { en, es, tr, pt, fr, de, it, ar, hi, ja, ko, zh };

// Deep-merge each locale over English so no key is ever missing.
function deepMerge(base, over) {
  if (Array.isArray(base)) return over !== undefined ? over : base;
  if (typeof base === "object" && base !== null) {
    const out = { ...base };
    Object.keys(base).forEach((k) => {
      if (over && over[k] !== undefined) out[k] = deepMerge(base[k], over[k]);
    });
    if (over) Object.keys(over).forEach((k) => { if (!(k in out)) out[k] = over[k]; });
    return out;
  }
  return over !== undefined ? over : base;
}

const DICT = {};
Object.keys(RAW).forEach((code) => {
  DICT[code] = code === "en" ? en : deepMerge(en, RAW[code]);
});

const I18nContext = createContext({ lang: DEFAULT_LANG, d: DICT.en, meta: getLang(DEFAULT_LANG) });

export function I18nProvider({ lang, children }) {
  const code = DICT[lang] ? lang : DEFAULT_LANG;
  const value = { lang: code, d: DICT[code], meta: getLang(code) };
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
